import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Module-level state so updates apply to next requests immediately,
// avoiding race conditions vs React effect ordering.
let _activeTenantId = localStorage.getItem("nariai_active_tenant") || "";

export function setActiveTenantId(id) {
  _activeTenantId = id || "";
  if (id) localStorage.setItem("nariai_active_tenant", id);
}

export function getActiveTenantId() {
  return _activeTenantId;
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("nariai_token");
  if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
  if (_activeTenantId) cfg.headers["X-Tenant-ID"] = _activeTenantId;
  return cfg;
});

export function setAuthToken(token) {
  if (token) localStorage.setItem("nariai_token", token);
  else localStorage.removeItem("nariai_token");
}

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
